<template>
  <div class="container">
    <!-- 成功反馈 -->
    <div class="feedback-card" v-if="type === 'success'">
      <div class="feedback-icon success-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <h2 class="feedback-title">操作成功</h2>
      <p class="feedback-message">储存卡已成功激活，您可以开始使用爱乐存服务了。</p>

      <div class="feedback-details">
        <div class="detail-item">
          <span class="detail-label">激活卡号：</span>
          <span class="detail-value">99011234</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">激活时间：</span>
          <span class="detail-value">2023-10-15 14:30</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">权益人：</span>
          <span class="detail-value">张三</span>
        </div>
      </div>

      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
      <p class="tip">页面将在5秒后自动跳转</p>

      <div class="feedback-actions">
        <button class="btn btn-primary" @click="goToHome">返回首页</button>
        <button class="btn btn-secondary" @click="viewDetails">查看详情</button>
      </div>
    </div>

    <!-- 错误反馈 -->
    <div class="feedback-card" v-else-if="type === 'error'">
      <div class="feedback-icon error-icon">
        <i class="fas fa-times-circle"></i>
      </div>
      <h2 class="feedback-title">操作失败</h2>
      <p class="feedback-message">激活码验证失败，请检查后重试或联系客服处理。</p>

      <div class="feedback-details">
        <div class="detail-item">
          <span class="detail-label">错误代码：</span>
          <span class="detail-value">ERR_ACTIVATION_002</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">建议操作：</span>
          <span class="detail-value">检查激活码或联系客服</span>
        </div>
      </div>

      <div class="feedback-actions">
        <button class="btn btn-primary" @click="tryAgain">重试</button>
        <button class="btn btn-secondary" @click="contactService">联系客服</button>
      </div>
    </div>

    <!-- 警告反馈 -->
    <div class="feedback-card" v-else-if="type === 'warning'">
      <div class="feedback-icon warning-icon">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <h2 class="feedback-title">信息不完整</h2>
      <p class="feedback-message">您的个人信息填写不完整，请补充完整后再次提交。</p>

      <div class="feedback-details">
        <div class="detail-item">
          <span class="detail-label">缺失信息：</span>
          <span class="detail-value">监护人手机号、儿童证件号码</span>
        </div>
      </div>

      <div class="feedback-actions">
        <button class="btn btn-primary" @click="completeInfo">完善信息</button>
        <button class="btn btn-secondary" @click="goBack">返回上一步</button>
      </div>
    </div>

    <!-- 信息反馈 -->
    <div class="feedback-card" v-else-if="type === 'info'">
      <div class="feedback-icon info-icon">
        <i class="fas fa-info-circle"></i>
      </div>
      <h2 class="feedback-title">提交审核中</h2>
      <p class="feedback-message">您的申请已提交，我们将在1-3个工作日内完成审核。</p>

      <div class="feedback-details">
        <div class="detail-item">
          <span class="detail-label">申请编号：</span>
          <span class="detail-value">AP20231015001</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">提交时间：</span>
          <span class="detail-value">2023-10-15 14:30</span>
        </div>
      </div>

      <div class="feedback-actions">
        <button class="btn btn-primary" @click="goToHome">返回首页</button>
        <button class="btn btn-secondary" @click="checkProgress">查看进度</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BindResult",
  data () {
    return {
      type: "success" // 默认展示成功，可以通过路由参数控制
    }
  },
  created () {
    // 通过 ?type=success/error/warning/info 控制反馈类型
    this.type = this.$route.query.type || "success"

    // 如果是成功类型，5秒后自动跳转
    if (this.type === "success") {
      setTimeout(() => this.goToHome(), 5000)
    }
  },
  methods: {
    goToHome () {
      this.$router.push("/mine")
    },
    viewDetails () {
      alert("查看详情页面")
    },
    tryAgain () {
      this.$router.go(-1)
    },
    contactService () {
      alert("联系客服")
    },
    completeInfo () {
      this.$router.push("/bind")
    },
    goBack () {
      this.$router.go(-1)
    },
    checkProgress () {
      alert("查看申请进度")
    }
  }
}
</script>

<style scoped>
 .container { margin: 0 auto; padding: 20px; text-align: center; }
.feedback-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  animation: cardAppear 0.6s ease;
}
.feedback-icon { font-size: 80px; margin-bottom: 25px; animation: iconBounce 0.8s ease; }
.success-icon { color: #2ecc71; }
.error-icon { color: #e74c3c; }
.warning-icon { color: #f39c12; }
.info-icon { color: #3498db; }
.feedback-title { font-size: 24px; font-weight: 600; margin-bottom: 15px; color: #2c3e50; }
.feedback-message { font-size: 16px; color: #7f8c8d; margin-bottom: 30px; line-height: 1.6; }
.feedback-details { background: #f8f9fa; border-radius: 10px; padding: 15px; margin: 20px 0; text-align: left; }
.detail-item { display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 14px; }
.detail-item:last-child { margin-bottom: 0; }
.detail-label { color: #7f8c8d; }
.detail-value { font-weight: 500; color: #2c3e50; }
.feedback-actions { display: flex; gap: 15px; margin-top: 25px; }
.btn { flex: 1; padding: 15px; border-radius: 10px; border: none; font-size: 16px; font-weight: 500; cursor: pointer; transition: all 0.3s; }
.btn-primary { background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%); color: white; }
.btn-primary:hover { opacity: 0.9; transform: translateY(-2px); box-shadow: 0 5px 15px rgba(52,152,219,0.3); }
.btn-secondary { background: #f8f9fa; color: #7f8c8d; border: 1px solid #ddd; }
.btn-secondary:hover { background: #e9ecef; }
.tip { font-size: 14px; color: #95a5a6; margin-bottom: 20px; }
@keyframes cardAppear {
  0% { opacity: 0; transform: translateY(30px) scale(0.95); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes iconBounce {
  0% { opacity: 0; transform: scale(0.3); }
  50% { transform: scale(1.1); }
  70% { transform: scale(0.9); }
  100% { opacity: 1; transform: scale(1); }
}
.progress-bar { height: 6px; background: #f0f0f0; border-radius: 3px; overflow: hidden; margin: 20px 0; }
.progress-fill { height: 100%; background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%); border-radius: 3px; animation: progressFill 5s linear; }
@keyframes progressFill {
  0% { width: 0%; }
  100% { width: 100%; }
}
</style>
